import React, { useEffect, useState } from 'react';
import { Field } from '@progress/kendo-react-form';
import {
  FormNumericTextBox,
  FormTextArea,
  FormFloatingNumericTextBox,
  FormInput
} from "src/shared/components/formControls";
import { upsertCCCStandard } from 'src/fetch/warehouse';
import toastr from 'shared/helpers/toastr';
import errorToastr from 'shared/helpers/errorToastr';
import isNil from 'lodash/isNil';
import PageForm from 'src/shared/components/forms/PageForm';
import { TabBar, Tab } from 'shared/layout/Tabs';
import { HistoryButton } from 'src/shared/components/buttons';
import EquipmentTypeDropdown from 'src/shared/components/dropdowns/EquipmentTypeDropdown';
import CCCCommodityDropdown from 'src/shared/components/dropdowns/CCCCommodityDropdown';
import ActivityTypeDropdown from 'src/shared/components/dropdowns/ActivityTypeDropdown';
import * as Yup from 'yup';
import AuditHomePage from '../../../audits/components/pages/AuditHomePage/AuditHomePage';

const CCCStandardForm = ({ initialValues, onClose, onDataUpdated, history }) => {
  const [formInitialValue, setFormInitialValue] = useState(initialValues || {});

  const handleSubmit = async (data) => {
    const { closeOnSubmit, ...cccStandard } = data;

    cccStandard.commodityId = !isNil(data.commodityId.value) ? data.commodityId.value : data.commodityId;
    cccStandard.activity = !isNil(data.activity.value) ? data.activity.value : data.activity;
    cccStandard.equipmentType = !isNil(data.equipmentType.value) ? data.equipmentType.value : data.equipmentType;

    await upsertCCCStandard(cccStandard)
      .then(() => {
        if (closeOnSubmit) {
          onClose();
        }
        toastr('success', 'CCC Standard Saved Successfully.');
      })
      .catch((error) => {
        errorToastr({
          error,
          messagePrefix: 'CCC Standard Save Failed!'
        });
      });
  };

  const handleDelete = async () => {
    const entity = {
      ...formInitialValue,
      isActive: false,
      isDeleted: true
    };

    await upsertCCCStandard(entity, { confirm: true }).then(() => {
      onClose(true);
      toastr('success', 'CCC Standard Deleted Successfully.');
    })
      .catch((error) => {
        errorToastr({
          error,
          messagePrefix: 'CCC Standard Delete Failed'
        });
      });
  };


  useEffect(() => {
    setFormInitialValue(initialValues);
  }, [initialValues]);

  const CCCStandardSchema = Yup.object().shape({
    commodityId: Yup.number().required('Commodity is required'),
    activity: Yup.number().required('Activity is required'),
    equipmentType: Yup.number().required('Equipment Type is required'),
  });

  return (
    <div>
      <PageForm
        id='ccc-standard-form'
        pageName='CCC Standard'
        itemName={`CCC Standard with Id ${formInitialValue?.id}`}
        onSubmit={handleSubmit}
        onClose={onClose}
        onDelete={handleDelete}
        initialValues={formInitialValue}
        showDeleteButton={formInitialValue && !isNil(formInitialValue.id)}
        key={JSON.stringify(formInitialValue)}
        validationSchema={CCCStandardSchema}
        renderFields={({ valueGetter, errors, onChange }) => (
          <TabBar>
            <Tab key='ccc-standard' title='CCC Standard'>
              <fieldset className={"k-form-fieldset"}>
                <Field component={FormInput} inputComponent={CCCCommodityDropdown} id={'commodityId'} name={'commodityId'} label={'Commodity'} />
                <Field component={FormInput} inputComponent={ActivityTypeDropdown} id={'activity'} name={'activity'} label={'Activity'} />
                <Field component={FormInput} inputComponent={EquipmentTypeDropdown} id={'equipmentType'} name={'equipmentType'} label={'Equipment Type'} />
                <Field id={'activityCode'} name={'activityCode'} label={'Activity Code'} format={'n0'} component={FormNumericTextBox} useGrouping={false} />
                <Field id={'activityDescription'} name={'activityDescription'} label={'Activity Description'} component={FormTextArea} />
                <Field id={'hours'} name={'hours'} label={'Hours'} component={FormNumericTextBox} useGrouping={false}/>
              </fieldset>
            </Tab>
            <Tab
              key='history'
              disabled={isNil(valueGetter('id'))}
              title={
                <HistoryButton
                  title='CCC Standard History'
                  disabled={isNil(valueGetter('id'))}
                />
              }
            >
              <AuditHomePage type='ccc-standards' id={valueGetter('id')} />
            </Tab>
          </TabBar>
        )}>
      </PageForm>
    </div>
  );
};

export default CCCStandardForm;